import { round } from 'lodash';

export const decimalToPercentageNumber = (
  decimalAmount: number,
  decimalPlaces: number = DEFAULT_DECIMAL_PLACES,
): number => round(decimalAmount * 100, decimalPlaces);

export const DEFAULT_DECIMAL_PLACES = 5;
export const decimalToPercentage = (decimalAmount: number, decimalPlaces: number = DEFAULT_DECIMAL_PLACES): string => {
  let formattedNumber = round(decimalAmount * 100, decimalPlaces).toFixed(decimalPlaces);
  if (decimalPlaces === 5) {
    // if the number ends with 00, remove the trailing 00
    formattedNumber = formattedNumber.replace(/00$/, '');
  }
  return `${formattedNumber}%`;
};
